export default {
  // 图集详情接口
  getGalleryDetailById: '/member/anonymous/amc/getAtlasContentById',
}